import React,{Component} from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Modal from "react-bootstrap/Modal";
import Wrp from "../../hoc/Wrp/Wrp";
import { callGET } from '../../Utils/ApiUtil';
import * as ShipConstants from '../../Global/Constants';
import { getUserInfo } from '../../Utils/UserFunctions';
import Buttons from '../../Components/UI/Buttons';
import * as actions from '../../store/actions';
import {
    setErrorListAction,
    clearErrorListAction,
} from '../../store/actions/ErrorSetupAction';
import {capitalizeFirstLetter, isSet}  from '../../Utils/CommonFunctions';

const CallErrorElements = (props) => {

	let {errorObject} = props;
    let {infoErrorList,warningErrorList,errorErrorList,infoErrorListCount,warningErrorListCount,errorErrorListCount} = errorObject;


	return(
		<div className="toast-main col-12 col-md-6 col-xl-4">

			{
				warningErrorListCount>0?
				<div className="toast show crm_Warning animated fadeInDown">    
		            <div className="d-flex align-items-center justify-content-between">
		               <div className="toast-icon p-2"> 
		                  <span data-notify="icon" className="fas fa-exclamation "></span> 
		               </div>
		               <div className="toast-body" style={{"width": "85%"}}> 
		                  <span data-notify="message"> 
		                     <span data-notify="title"> {warningErrorListCount} Warning found </span>
		                     <div className="text-dark w-100">   
		                        <p className="mb-0" title="">
		                        {isSet(warningErrorList[0].message,null)!==null?warningErrorList[0].message:''}
								</p>                              
		                     </div> 
		                  </span>                        
		               </div>
		            </div>                      
		         </div>
				:
				<></>
			}

			{
				infoErrorListCount>0?
				<div className="toast show crm_Info animated fadeInDown">    
		            <div className="d-flex align-items-center justify-content-between">
		               <div className="toast-icon p-2"> 
		                  <span data-notify="icon" className="fas fa-exclamation "></span> 
		               </div>
		               <div className="toast-body" style={{"width": "85%"}}> 
		                  <span data-notify="message"> 
		                     <span data-notify="title"> {infoErrorListCount} Info's found </span>
		                     <div className="text-dark w-100">   
		                        <p className="mb-0" title="">
		                        {isSet(infoErrorList[0].message,null)!==null?infoErrorList[0].message:''}
								</p>                              
		                     </div> 
		                  </span>                        
		               </div>
		            </div>                      
		         </div>
				:
				<></>
			}

			{
				errorErrorListCount>0?
				<div className="toast show crm_Error animated fadeInDown">    
		            <div className="d-flex align-items-center justify-content-between">
		               <div className="toast-icon p-2"> 
		                  <span data-notify="icon" className="fas fa-exclamation "></span> 
		               </div>
		               <div className="toast-body" style={{"width": "85%"}}> 
		                  <span data-notify="message"> 
		                     <span data-notify="title"> {errorErrorListCount} Errors Occured </span>
		                     <div className="text-dark w-100">   
		                        <p className="mb-0" title="">
		                        {isSet(errorErrorList[0].message,null)!==null?errorErrorList[0].message:''}
								</p>                              
		                     </div> 
		                  </span>                        
		               </div>
		            </div>                      
		         </div>
				:
				<></>
			}
	         	                      	           	
	    </div>
	)
}

const mapDispatchToProps = dispatch => {
    return {      
      setErrorListAction:(arr)=>dispatch(setErrorListAction(arr)),
      clearErrorListAction:(arr)=>dispatch(clearErrorListAction(arr)),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      warningMessage : (msg) => dispatch(actions.warningMessage(msg)),
      infoMessage : (msg) => dispatch(actions.infoMessage(msg)),
    };
  }
const mapStateToProps = (state) => { 
	return {    
		isErrorModalOpen:state.ErrorSetupReducer.isErrorModalOpen,    
	    errorsList:state.ErrorSetupReducer.errorsList
	};
}

export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(CallErrorElements);

//export default CallErrorElements;